import { createSvgComponent } from "../../icon/createSvgComponent";
import Info from "@core/__generated__/icon/figma/info.svg";
export default createSvgComponent(Info);